module.exports = __webpack_public_path__ + "img/mobile/General/spelser@1x.png?1.0.17";